const LAND_PATHS = [
  'M29.4,-17.4C33.1,1.8,27.6,16.1,11.5,31.6C-4.7,47,-31.5,63.6,-43,56C-54.5,48.4,-50.7,16.6,-41,-10.9C-31.3,-38.4,-15.6,-61.5,-1.4,-61C12.8,-60.5,25.7,-36.5,29.4,-17.4Z',
  'M31.7,-55.8C40.3,-50,45.9,-39.9,49.7,-29.8C53.5,-19.8,55.5,-9.9,53.1,-1.4C50.6,7.1,43.6,14.1,41.8,27.6C40.1,41.1,43.4,61.1,37.3,67C31.2,72.9,15.6,64.8,1.5,62.2C-12.5,59.5,-25,62.3,-31.8,56.7C-38.5,51.1,-39.4,37.2,-49.3,26.3C-59.1,15.5,-78,7.7,-77.6,0.2C-77.2,-7.2,-57.4,-14.5,-49.3,-28.4C-41.2,-42.4,-44.7,-63,-38.5,-70.1C-32.2,-77.2,-16.1,-70.8,-2.3,-66.9C11.6,-63,23.1,-61.5,31.7,-55.8Z',
  'M30.6,-49.2C42.5,-46.1,57.1,-43.7,67.6,-35.7C78.1,-27.6,84.6,-13.8,80.3,-2.4C76.1,8.9,61.2,17.8,52.5,29.1C43.8,40.3,41.4,53.9,33.7,64C26,74.1,13,80.6,2.2,76.9C-8.6,73.1,-17.3,59,-30.6,52.1C-43.9,45.3,-61.9,45.7,-74.1,38.2C-86.4,30.7,-92.9,15.4,-88.6,2.5C-84.4,-10.5,-69.4,-20.9,-60.7,-34.6C-52.1,-48.3,-49.8,-65.3,-40.7,-70C-31.6,-74.8,-15.8,-67.4,-3.2,-61.8C9.3,-56.1,18.6,-52.3,30.6,-49.2Z',
  'M39.4,-66C48.6,-62.9,51.9,-47.4,52.9,-34.3C53.8,-21.3,52.4,-10.6,54.4,1.1C56.3,12.9,61.7,25.8,57.5,33.2C53.2,40.5,39.3,42.3,28.2,46C17,49.6,8.5,55.1,1.3,52.8C-5.9,50.5,-11.7,40.5,-23.6,37.2C-35.4,34,-53.3,37.5,-62,32.4C-70.7,27.4,-70.4,13.7,-72.4,-1.1C-74.3,-15.9,-78.6,-31.9,-73.3,-43C-68.1,-54.2,-53.3,-60.5,-39.5,-60.9C-25.7,-61.4,-12.9,-56,1.1,-58C15.1,-59.9,30.2,-69.2,39.4,-66Z',
] as const;

function landSvg(path: string): SVGSVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  svg.setAttribute('viewBox', '0 0 200 200');
  const p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  p.setAttribute('transform', 'translate(100 100)');
  p.setAttribute('d', path);
  p.setAttribute('fill', '#7CC133');
  svg.appendChild(p);
  return svg;
}

/** Loader « planète » — composant de chargement global de l’app (hors infinite scroll). */
export function createEarthLoader(message = 'Chargement…'): HTMLElement {
  const block = document.createElement('div');
  block.className = 'earth-loader-block';
  block.setAttribute('role', 'status');
  block.setAttribute('aria-live', 'polite');
  block.setAttribute('aria-busy', 'true');

  const globe = document.createElement('div');
  globe.className = 'earth-loader';
  for (const path of LAND_PATHS) {
    globe.appendChild(landSvg(path));
  }

  const label = document.createElement('p');
  label.textContent = message;

  block.append(globe, label);
  return block;
}

/**
 * Variante compacte pour vignettes (cartes replays) : globe mis à l’échelle dans
 * une coque fixe pour rester parfaitement centré (les SVG land sont en `em`
 * calés sur 7.5em — on scale plutôt que de casser les anims).
 */
export function createCardEarthLoader(message = 'Chargement…'): HTMLElement {
  const block = createEarthLoader(message);
  block.classList.add('circuit-preview-earth-loader');
  const globe = block.querySelector('.earth-loader');
  if (globe) {
    const shell = document.createElement('div');
    shell.className = 'circuit-preview-earth-loader-globe';
    globe.replaceWith(shell);
    shell.appendChild(globe);
  }
  return block;
}

/** Overlay centré sur un conteneur ; retourne une fonction pour le retirer. */
export function mountEarthLoaderOverlay(host: HTMLElement, message = 'Chargement…'): () => void {
  const prevPosition = host.style.position;
  if (!prevPosition || prevPosition === 'static') {
    host.style.position = 'relative';
  }

  const overlay = document.createElement('div');
  overlay.className = 'earth-loader-overlay';
  overlay.appendChild(createEarthLoader(message));
  host.appendChild(overlay);

  return () => {
    overlay.remove();
    if (!prevPosition || prevPosition === 'static') {
      host.style.position = prevPosition;
    }
  };
}

/**
 * Remplace le contenu du host par le loader planète (chargement de page / vue).
 * À utiliser à l’arrivée sur une page en attendant les données — pas pour l’infinite scroll.
 */
export function mountEarthLoaderPage(host: HTMLElement, message = 'Chargement…'): () => void {
  const page = document.createElement('div');
  page.className = 'earth-loader-page';
  page.appendChild(createEarthLoader(message));
  host.replaceChildren(page);
  return () => {
    page.remove();
  };
}
